// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"14c23d66","620":"130d78d0","656":"f72d7c33","695":"9cdaff06","796":"b663b53e"}[chunkId] + ".chunk.js";
};